import m from "../../geodata/es2015/colombiaHigh";
window.am4geodata_colombiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/colombiaHigh.js
// module id = null
// module chunks = 